import React from 'react';
import AnimatedNumber from 'animated-number-react';
import { Typography } from '@material-ui/core';
import Box from '@material-ui/core/Box';

import { BalanceCurrency } from 'features/app/ts/BalanceCurrency';
import { formatCurrencyNumber } from 'features/app/utils/formatCurrencyNumber';

import { useStyles } from './styles';

type Props = {
  balance?: BalanceCurrency;
};

export const UserBalanceItem: React.FC<Props> = ({ balance }) => {
  const classes = useStyles();

  return (
    <Box className={classes.userBalanceContainer}>
      <Typography variant="h6" className={classes.balanceCurrencyCode}>
        {balance?.currency_code}
      </Typography>

      <AnimatedNumber className={classes.balanceValue} value={balance?.value} formatValue={formatCurrencyNumber} />
    </Box>
  );
};